<script setup>
  const { menuTop } = useMainMenuIrol()
  const localePath = useLocalePath()
</script>

<template>
  <nav class="bg-sky-950 font-body h-8">
    <div class="container flex justify-between items-center">
      <NuxtLink class="font-light text-xs text-white" :to="localePath({ name: 'index' })">
        {{ $t('menu.MenuTop.uia') }}
      </NuxtLink>
      <ul class="text-xs flex justify-end font-light text-white h-8">
        <li v-for="page in menuTop" :key="page.title" class="flex items-center h-8">
          <Button as-child pt:root="!h-8 !py-0">
            <NuxtLink
              class="text-xs text-white hover:text-sky-100 flex px-3 h-8 items-center"
              :to="localePath({ name: page.items[0].path, params: page.items[0].params || {} })"
            >
              {{ page.title }}
            </NuxtLink>
          </Button>
        </li>
        <li class="border-l border-white/50 h-8 flex items-center">
          <MenuLanguage />
        </li>
      </ul>
    </div>
  </nav>
</template>
